import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon'
import { mdiLogout } from '@mdi/js'
import { FunctionComponent } from 'react'

export const IconLogout: FunctionComponent<SvgIconProps> = (props: SvgIconProps) => (
	<SvgIcon {...props}>
		<path d={mdiLogout} />
	</SvgIcon>
)
